var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinervaPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "minerva_pdf_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.951,
    height: 90.026,
    viewBox: "0 0 78.951 90.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139139",
    "data-name": "\\uD328\\uC2A4 139139",
    d: "M64.912,85.795H1.821A1.821,1.821,0,0,1,0,83.974V1.821A1.821,1.821,0,0,1,1.821,0H64.912a1.821,1.821,0,0,1,1.821,1.821V83.974A1.821,1.821,0,0,1,64.912,85.795Z",
    transform: "translate(12.218 4.231)",
    fill: "#939598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139140",
    "data-name": "\\uD328\\uC2A4 139140",
    d: "M43.376,0H1.821A1.821,1.821,0,0,0,0,1.821V83.974A1.821,1.821,0,0,0,1.821,85.8H64.912a1.821,1.821,0,0,0,1.821-1.821V22.6Z",
    transform: "translate(7.987 0)",
    fill: "#f1f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139141",
    "data-name": "\\uD328\\uC2A4 139141",
    d: "M.91,75.808A.913.913,0,0,1,0,74.9V.91A.914.914,0,0,1,.269.269.9.9,0,0,1,.91,0H27.077a.91.91,0,1,1,0,1.821H1.821V74.9A.91.91,0,0,1,.91,75.808ZM30.719,1.821a.91.91,0,1,1,.91-.91A.91.91,0,0,1,30.719,1.821Z",
    transform: "translate(9.807 1.82)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139142",
    "data-name": "\\uD328\\uC2A4 139142",
    d: "M62.181,0V61.225a1.821,1.821,0,0,1-1.821,1.821H0v2.731A1.821,1.821,0,0,0,1.821,67.6H64.912a1.821,1.821,0,0,0,1.821-1.821V4.405Z",
    transform: "translate(7.987 18.197)",
    fill: "#e6e7e8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139143",
    "data-name": "\\uD328\\uC2A4 139143",
    d: "M64.457,0V61.3a1.821,1.821,0,0,1-1.821,1.821H0v.455A1.821,1.821,0,0,0,1.821,65.4H64.912a1.821,1.821,0,0,0,1.821-1.821V2.2Z",
    transform: "translate(7.987 20.4)",
    fill: "#d1d3d4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139144",
    "data-name": "\\uD328\\uC2A4 139144",
    d: "M0,20.9A1.707,1.707,0,0,0,1.707,22.6H23.358L0,0Z",
    transform: "translate(51.362)",
    fill: "#d1d3d4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139145",
    "data-name": "\\uD328\\uC2A4 139145",
    d: "M43,16.255H1.821A1.821,1.821,0,0,1,0,14.434V1.821A1.821,1.821,0,0,1,1.821,0H43a1.821,1.821,0,0,1,1.821,1.821V14.434A1.821,1.821,0,0,1,43,16.255Z",
    transform: "translate(0 6.347)",
    fill: "#e63950"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139150",
    "data-name": "\\uD328\\uC2A4 139150",
    d: "M28.331,4.1H2.048a2.049,2.049,0,0,1,0-4.1H28.331a2.049,2.049,0,1,1,0,4.1Z",
    transform: "translate(16.491 31.329)",
    fill: "#e8566f"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139151",
    "data-name": "\\uD328\\uC2A4 139151",
    d: "M47.786,4.1H2.048a2.048,2.048,0,1,1,0-4.1H47.786a2.048,2.048,0,1,1,0,4.1Z",
    transform: "translate(16.491 44.164)",
    fill: "#b7022d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139152",
    "data-name": "\\uD328\\uC2A4 139152",
    d: "M28.331,4.1H2.048a2.049,2.049,0,0,1,0-4.1H28.331a2.049,2.049,0,1,1,0,4.1Z",
    transform: "translate(16.491 56.999)",
    fill: "#e8566f"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139153",
    "data-name": "\\uD328\\uC2A4 139153",
    d: "M47.786,4.1H2.048a2.049,2.049,0,0,1,0-4.1H47.786a2.049,2.049,0,1,1,0,4.1Z",
    transform: "translate(16.491 69.834)",
    fill: "#b7022d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139382",
    "data-name": "\\uD328\\uC2A4 139382",
    d: "M2.274,6.849v3.535H0V0H3.928A4.884,4.884,0,0,1,6.994.823,2.879,2.879,0,0,1,8.041,3.232,3.28,3.28,0,0,1,6.884,5.867a4.505,4.505,0,0,1-3.018.982ZM2.26,1.633V5.2h.606A3.736,3.736,0,0,0,5.13,4.73a1.8,1.8,0,0,0,.555-1.45,1.467,1.467,0,0,0-.534-1.227,3.668,3.668,0,0,0-2.112-.42Zm7.569,8.751V0h3.245a8.45,8.45,0,0,1,3.438.565A4.359,4.359,0,0,1,18.46,2.3a5.486,5.486,0,0,1,.713,2.9,5.382,5.382,0,0,1-.741,2.808,4.4,4.4,0,0,1-1.981,1.809,8.206,8.206,0,0,1-3.349.565ZM12.1,1.633V8.751h1.116q3.576,0,3.576-3.569,0-3.549-3.576-3.549Zm16.279.09h-5V4.031h4.534V5.747h-4.52v4.637H21.119V0h7.263Z",
    transform: "translate(8.863 9.19)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinervaPdfIcon);
export default __webpack_public_path__ + "static/media/minerva_pdf_icon.4d4deb6cf7ab43c56e5046f8b6e30ec2.svg";
export { ForwardRef as ReactComponent };